/** @jsxImportSource theme-ui */
import React from 'react';

import BdPngExportHeader from 'components/_controls/PngExports/BdPngExportHeader';

import RiskOverviewBepiExportContainer from '../RiskOverviewBepiExportContainer';
import RiskOverviewCardLandscapeContainer from './RiskOverviewCardLandscapeContainer';

type RiskOverviewCardBepiLandscapeProps = { header: string; locationId: number };

const RiskOverviewCardBepiLandscape: React.FC<RiskOverviewCardBepiLandscapeProps> = ({
  header,
  locationId,
}) => {
  return (
    <RiskOverviewCardLandscapeContainer>
      <BdPngExportHeader title={header} superTitle="Your risk of" supertitleVariant="overline" />
      <RiskOverviewBepiExportContainer
        locationId={locationId}
        showDisruptionTitle
        sx={{ mt: '32px', '& .bepi-stats': { mt: '24px' } }}
      />
    </RiskOverviewCardLandscapeContainer>
  );
};

export default RiskOverviewCardBepiLandscape;
